const ServiceCardShimmer = () => {
  return (
    <div className="flex flex-col bg-surface-primary shadow-fab px-3 py-2 rounded-lg">
      <div className="w-20 h-5 bg-surface-secondary rounded-full animate-pulse" />

      <div className="w-[180px] h-[104px] bg-surface-secondary rounded-lg animate-pulse mt-1" />

      <span className="w-32 h-4 bg-surface-secondary rounded-lg animate-pulse mt-2" />

      <span className="w-28 h-4 bg-surface-secondary rounded-lg animate-pulse mt-7" />

      <span className="w-24 h-4 bg-surface-secondary rounded-lg animate-pulse mt-2" />

      <div className="w-full h-[1px] bg-surface-secondary mt-2 ml-6" />

      <div className="flex items-center justify-between mt-2">
        <span className="w-20 h-4 bg-surface-secondary rounded-lg animate-pulse" />

        <span className="w-16 h-4 bg-surface-secondary rounded-lg animate-pulse" />
      </div>

      <span className="w-40 h-5 bg-surface-secondary rounded-full animate-pulse my-1" />
    </div>
  );
};

export default ServiceCardShimmer;
